import {
  collection,
  getDocs,
  doc,
  getDoc,
  query,
  where,
  orderBy
} from 'firebase/firestore';
import { db } from './config';

const COLLECTION = 'services';

export const serviceService = {
  async getAll() {
    const q = query(
      collection(db, COLLECTION),
      where('showOnWebsite', '==', true),
      orderBy('order', 'asc')
    );
    const snapshot = await getDocs(q);
    return snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
  },

  async getBySlug(slug) {
    const q = query(
      collection(db, COLLECTION),
      where('slug', '==', slug),
      where('showOnWebsite', '==', true)
    );
    const snapshot = await getDocs(q);
    if (snapshot.empty) {
      return null;
    }
    const docSnap = snapshot.docs[0];
    return {
      id: docSnap.id,
      ...docSnap.data()
    };
  },

  async getById(id) {
    const docRef = doc(db, COLLECTION, id);
    const docSnap = await getDoc(docRef);
    if (!docSnap.exists()) {
      return null;
    }
    return {
      id: docSnap.id,
      ...docSnap.data()
    };
  }
};

export default serviceService;
